import React from 'react';
import {connect} from 'react-redux';
import clx from 'classnames';

import * as resources from 'constants/accountResourceNames';
import { minAmount } from 'constants/StakeMinAmount';
import { maxAmount } from 'constants/StakeMaxAmount';
import { isMinAndMaxValueWrong } from '../CouponDropDownMenu.jsx';

class FavouriteBetAmount extends React.Component {
    static propTypes = {
        amount: React.PropTypes.number.isRequired,
        number: React.PropTypes.number.isRequired,
        callback: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this._onClick = this._onClick.bind(this);
    }

    _onClick(e) {
        e.preventDefault();
        this.props.callback(this.props.amount);
    }

    render() {
        const {amount, user, number} = this.props;
        const cls = 'fav-bet-' + number;

        let resourceId;
        let currency;
        let minStakeAmount = 0;
        let maxStakeAmount = 0;

        if (user) {
            resourceId = user.get('resourceId');
            currency = resources.resourceNames[resourceId];
            minStakeAmount = minAmount[currency]
            maxStakeAmount = maxAmount[currency]
        }

        const disabled = user && isMinAndMaxValueWrong(minStakeAmount, maxStakeAmount, amount)

        return (
            <a href="#" className={clx(cls, {disabled})} onClick={disabled ? null : this._onClick}>{amount}</a>
        );
    }
}

function select(state) {
    return {
        countryCode: state.application.get('countryCode'),
        user: state.auth.get('user'),
    };
}

export default connect(select)(FavouriteBetAmount);


// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/coupon/FavouriteBetAmount.jsx